import config from 'config'
import lang from '@/lang'
import { projectStates } from '@/modules/base/util/constants'
const { DRAFT, STARTED, FINISHED } = projectStates

const urls = {
  single: 'project',
  multiple: 'projects',
}

const resourceUrl = `${config.resourceHost}project`

export default {
  resourceUrl,
  apiUrl: config.resourceHost,
  projectListSetting: `${config.resourceHost}setting/userlist/project`,
  getNewProject: `${resourceUrl}/new`,

  clientUrl: urls,

  routes: {
    details: `/${urls.single}/`,
    list: `/${urls.multiple}`,
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: null,
    },
    {
      name: DRAFT,
      title: lang.notStarted,
      quickFilter: {
        state: {
          type: 'set',
          values: [DRAFT],
        },
      },
    },
    {
      name: STARTED,
      title: lang.started,
      quickFilter: {
        state: {
          type: 'set',
          values: [STARTED],
        },
      },
    },
    {
      name: FINISHED,
      title: lang.finished,
      quickFilter: {
        state: {
          type: 'set',
          values: [FINISHED],
        },
      },
    },
  ],
}
